import angular from "angular";
import { confirmationConfig } from "./confirmation";
import { containerConfig } from "./container";
import { labelWrapperConfig } from "./wrappers/label";
import { childrenWrapperConfig } from "./wrappers/children";
import {
  WorkItemServiceProvider,
  vsServiceName as WorkItemServiceName,
} from "./";
import { optionConfig } from "./option";
import { listConfig } from "./list";
import { textConfig } from "./text";
import { dateConfig } from "./date";

export const vsModuleName = "processFormlyTypesModule";

angular
  .module(vsModuleName, [])
  .provider(WorkItemServiceName, WorkItemServiceProvider)
  .config(confirmationConfig)
  .config(labelWrapperConfig)
  .config(childrenWrapperConfig)
  .config(containerConfig)
  .config(optionConfig)
  .config(listConfig)
  .config(textConfig)
  .config(dateConfig);
